"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// A packages cache that makes sure that we don't inject the same packageName twice in the same bundle -
// this cache is local to the module closure inside this bundle
var packagesCache = {};
function setVersion(packageName, packageVersion) {
    if (typeof window !== 'undefined') {
        // tslint:disable-next-line:no-any
        var packages = (window.__packages__ = window.__packages__ || {});
        // We allow either the global packages or local packages caches to invalidate so testing can just clear the global to set this state
        if (!packages[packageName] || !packagesCache[packageName]) {
            packagesCache[packageName] = packageVersion;
            var versions = (packages[packageName] = packages[packageName] || []);
            versions.push(packageVersion);
        }
    }
}
exports.setVersion = setVersion;
//# sourceMappingURL=setVersion.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uifabric/set-version/lib-commonjs/setVersion.js
// module id = 466
// module chunks = 0